import { ChangeDetectionStrategy,Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

export interface LinkFulfillerAppDialogResult {
    appId: string;
}

@Component({
    templateUrl: './link-fulfiller-app-dialog.component.html',
    styleUrls: ['./link-fulfiller-app-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, MatDialogContent, FormsModule, MatFormField, MatLabel, MatInput, MatHint, MatDialogActions, MatButton, MatDialogClose],
})
export class LinkFulfillerAppDialogComponent {
    dialogRef = inject<MatDialogRef<LinkFulfillerAppDialogResult>>(MatDialogRef);

    fulfillerInfo: LinkFulfillerAppDialogResult = {
        appId: '',
    };

    valid() {
        this.dialogRef.close(this.fulfillerInfo);
    }
}
